webpackJsonp([114276838955818,60335399758886],{

/***/ 90:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(141);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(90);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(16);
	var isArguments = __webpack_require__(15);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(21);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(14);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(20);
	
	var _HelmetConstants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(35);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(17));
	var shallowEqual = _interopDefault(__webpack_require__(22));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAC90lEQVQ4EXVTXUiTURg+37eNOadB5pa/lIEyhKGg6ObPfqRosql4IW4DBdG60IQuhMBt4IXgrYwIlld6obGFgV7sYkUFM4hIkgRtG7EYZdusG0Ualqfn/ZziRR0433n/zvu+53mfjzHGRJPJ9EmcmZlhgiBwYXJy8mY2m9ULcPHe3t4o45zLWltb31BsW1vbC/LIsH83NTUl6+vrP0BmDKGhurq6DUmZmJhwGAyGz6RotVrOUqmUanV19Qp0Tkb56Ojo/aKiIhMptIR4PK6sra39VVhYyPR6/ZpGo0nlcrnrkUjEbrFYkiKcOQqEkZWXl0dw+xDrGt1uaGjwsIGBAdnQ0JAZulSDHE6nM6BWq891mdls9ldVVfG+vr7FwcHB2YWFhasUeL62trbUuOVF+xs9PT1fu7u715aXl0sRIIr9/f2vUOswkUg4y8rKUsfHx88AVpfb7c5Go1E1GxsbcwEvNaK53++/hFOZT81dLpeN5AK73e5TKpU8EAiUQn5MCDU2NkpNSsDC8KigoEDA837EYrG7yWRSvbe3p8CATpNVVlb+MRqNQWjyUwvjHR0dXsgyKUSlUnGgGFMoFN92dnYsoiiy/f19Ab0JIt2gVCUlJQm5XB4fHh52kxMcEIkDUsbd3d3ikZERT2dnZ7yiooKM/90YBQczvk9PT1ul5MikW1lZ2Tk6OmKgTri6uvodsCrG3NY9Hs9LqUL+Mz8/b1paWgptbm7i3Vpms9luXfQz4NZ11gG6Wb/opPeAbA/APCIHb29vzwSDQc1ZjPRW0OcpOYEa9/l8RqvV+oT0sw0MOEb9Gl0b8hcFiU2keL3eGp1O95OCm5ub36OilBSncm5u7gZgf0s+2g6H4x5OWnIxFApJo9je3jZnMpnLZAXzngPhE2o7HA4r0+n07YODg3ryASMGjn8hGVSmhNJvxvB/PoRMBumNeVmqSNRpaWlJj4+PzyKpAj5GY6STqtPmU1NTNWDpHcgfFxcXV3D+a8mQ4OR8/oj4C66tM1Lf2ik2AAAAAElFTkSuQmCC"

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _x = __webpack_require__(23);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _x3 = __webpack_require__(24);
	
	var _x4 = _interopRequireDefault(_x3);
	
	var _x5 = __webpack_require__(25);
	
	var _x6 = _interopRequireDefault(_x5);
	
	__webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var IndexLayout = function (_React$Component) {
	  _inherits(IndexLayout, _React$Component);
	
	  function IndexLayout() {
	    _classCallCheck(this, IndexLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexLayout.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "Bernie Graham",
	        meta: [{
	          name: "description",
	          content: "Bernie Graham - Sr. Software Engineer and Engineering Manager"
	        }, {
	          name: "keywords",
	          content: "Scala, go, golang, python, aws"
	        }],
	        link: [{
	          rel: "icon",
	          type: "image/png",
	          sizes: "16x16",
	          href: "" + _x2.default
	        }, {
	          rel: "icon",
	          type: "image/png",
	          sizes: "32x32",
	          href: "" + _x4.default
	        }, {
	          rel: "shortcut icon",
	          type: "image/png",
	          href: "" + _x6.default
	        }]
	      }),
	      this.props.children()
	    );
	  };
	
	  return IndexLayout;
	}(_react2.default.Component);
	
	IndexLayout.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = IndexLayout;
	module.exports = exports["default"];

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-48b0a25ca1f9a3b1fe23.js